module.exports = __webpack_public_path__ + "img/docking-2.3124fce1.png";